import { Typography } from "@mui/material";
import Paper from "@components/Paper/Paper";
import PaperItem from "@components/Paper/PaperItem";
import DocumentCard from "@features/vessel-nomination/nomination-details/components/DocumentCard/DocumentCard.tsx";
import { useDownloadNominationDocument } from "@features/vessel-nomination/nomination-details/hooks/useDownloadNominationDocument.tsx";
import { useTranslation } from "react-i18next";
import { useOutletContext } from "react-router-dom";
import type { VesselNominationDetailsOutletContext } from "../VesselNominationDetails";

const Documents = () => {
  const { t } = useTranslation();
  const { nominationDetails } = useOutletContext<VesselNominationDetailsOutletContext>();
  const { handleDownload, handlePreview } = useDownloadNominationDocument();

  const documents = nominationDetails?.documents || [];
  const paqDocument = nominationDetails?.paqDocument;
  const remarks = nominationDetails?.remarks?.trim() || "-";

  const documentsList = [
    ...(paqDocument
      ? [
          {
            slot: "PAQ",
            fileUrl: paqDocument.fileUrl,
            documentName: paqDocument.documentName,
            documentType: "DOCUMENT",
            issueDate: undefined,
            norTime: undefined,
            expiryDate: undefined,
            updatedAt: paqDocument.updatedAt,
          },
        ]
      : []),
    ...documents,
  ];

  return (
    <div className="mt-8 flex flex-col gap-4">
      <Paper variant="outlined">
        <Typography variant="body2" sx={{ marginBottom: 1 }}>
          {t("vessel-nomination.add.form.fields.remarks")}
        </Typography>
        <PaperItem
          testId="vessel-nomination-details-remarks-instructions"
          text={remarks}
          translate={t("vessel-nomination.add.form.fields.remarks")}
          labelClassName="sr-only"
          valueClassName="w-full"
        />
      </Paper>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-testid="documents-list">
        {documentsList.map((document, index) => {
          return (
            <DocumentCard
              key={index}
              testId={`document-${index}`}
              title={document.slot ?? undefined}
              documentName={document.documentName}
              documentType={document.documentType}
              issueDate={document.issueDate}
              norTime={document.norTime}
              expiryDate={document.expiryDate}
              updateDate={document.updatedAt}
              onPreview={() => handlePreview("bff-vessel", document.fileUrl)}
              onDownload={() =>
                handleDownload("bff-vessel", document.fileUrl, document.documentName)
              }
            />
          );
        })}
      </div>
    </div>
  );
};

export default Documents;
